<template>
  <div style="height: 100%; width: 100%">

    <div dir="rtl" class="report-box">
        <div class="toggle-div" v-b-toggle.collapse-1>{{ $t('Plan Report')}}</div>
          <b-collapse id="collapse-1" class="mt-1">
            <b-card style=" border-radius: 0;" class="no-border-radius">

              <b-table-simple small bordered responsive>
                <b-tr>
                  <b-td class="text-center">{{device}}</b-td>
                </b-tr>
                <b-tr>
                  <b-td class="text-center">{{contract}}</b-td>
                </b-tr>
              </b-table-simple>

              <b-table-simple small bordered responsive>
                <b-tr>
                  <b-td class="text-center">من تاريخ</b-td>
                  <b-td class="text-center">{{$router.currentRoute.params.from}}</b-td>
                </b-tr>
                <b-tr>
                  <b-td class="text-center">الى تاريخ</b-td>
                  <b-td class="text-center">{{$router.currentRoute.params.to}}</b-td>
                </b-tr>
              </b-table-simple>


              <b-table-simple small bordered responsive>
                <b-tr>
                  <b-td class="text-center"> عدد حاويات المسار  </b-td>
                  <b-td class="text-center">
                  </b-td>
                  <b-td class="text-center">{{ plan_route_count }}</b-td>
                </b-tr>

                <b-tr>
                  <b-td class="text-center">حاويات تم خدمتها طبقا للمسار</b-td>
                  <b-td class="text-center">
                     <span style="background: #1676e5" class="point"></span>
                  </b-td>
                  <b-td class="text-center">{{ in_route_in_range }}</b-td>
                </b-tr>
                <b-tr>
                  <b-td class="text-center">حاويات تم خدمتها طبقا للمسار ولكن خارج النطاق </b-td>
                  <b-td class="text-center">
                    <span style="background: #ee7b4e" class="point"></span>
                  </b-td>
                  <b-td class="text-center">{{ in_route_out_range }}</b-td>
                </b-tr>

                <b-tr>
                  <b-td class="text-center">حاويات تم خدمتها خارج المسار</b-td>
                  <b-td class="text-center">
                    <span style="background: #eeeb4e" class="point"></span>
                  </b-td>
                  <b-td class="text-center">{{ out_route }}</b-td>
                </b-tr>

                <b-tr>
                  <b-td class="text-center">حاويات لم تخدم بعد</b-td>
                  <b-td class="text-center">
                    <span style="background: red" class="point"></span>
                  </b-td>
                  <b-td class="text-center">{{ need_to_serve }}</b-td>
                </b-tr>

              </b-table-simple>

            </b-card>
          </b-collapse>
    </div>

    <div id="mapObj" ref="mapElement" style="height: 100vh; width: 100%;"></div>
  </div>
</template>

<script>

import { ref, onMounted, onBeforeUnmount } from '@vue/composition-api'
import L from 'leaflet';
import 'leaflet/dist/leaflet.css'
import router from '@/router'
import axios from '@/libs/axios'
import {BCollapse, BCard, BButton, BTable, BTr, BTd, BTableSimple} from 'bootstrap-vue'


export default {
  components: {
    BCollapse,BCard,BButton,
    BTable, BTr, BTd, BTableSimple
  },

  setup() {

    const mapElement = ref(null)


    const device = ref(null)
    const contract = ref(null)
    const plan_route_count = ref(0)
    const in_route_in_range = ref(0)
    const in_route_out_range = ref(0)
    const out_route = ref(0)
    const need_to_serve = ref(0)

    const bounds = new L.LatLngBounds();

    let containers = []
    let map = null

    document.getElementsByTagName('html')[0].dir = "ltr"

    onMounted(() => {

      axios.post('maps/getDevicePlanAchievement', {
        id: router.currentRoute.params.id,
        from: router.currentRoute.params.from,
        to: router.currentRoute.params.to,
      }).then(res => {


        device.value =  res.data.device
        contract.value = res.data.contract
        plan_route_count.value = res.data?.plan_route_count

        in_route_in_range.value = res.data?.served_in_route_in_range?.length
        in_route_out_range.value = res.data?.served_in_route_out_range?.length
        out_route.value = res.data?.served_out_route?.length
        need_to_serve.value = res.data?.need_to_serve?.length


        for (const i in res.data.served_in_route_out_range) {
          let container = L.circle([parseFloat(res.data.served_in_route_out_range[i].position.latitude),
                parseFloat(res.data.served_in_route_out_range[i].position.longitude)],
              { color: '#ee7b4e', fillColor: '#ee7b4e', fillOpacity: 0.5, radius: 5 })
              .addTo(map)
              // .bindPopup(popup({tag: res.data.served_in_route_out_range[i].tag,
              //   time: res.data.served_in_route_out_range[i].event_time}))
              .on('click', (e) => {

                L.circle([res.data.served_in_route_out_range[i].original_posiotn.lat,
                  res.data.served_in_route_out_range[i].original_posiotn.lng], {color: "black", fillColor: 'black', radius: 5 }).addTo(map)

              }).bindPopup(popup({tag: res.data.served_in_route_out_range[i].tag,  code: res.data.served_in_route_out_range[i].container?.name,
            time: res.data.served_in_route_out_range[i].event_time}))

          containers[i] = container;
          bounds.extend(container.getBounds());
          map.fitBounds(bounds);
        }


        for (const i in res.data.served_in_route_in_range) {
          let container = L.circle([
              parseFloat(res.data.served_in_route_in_range[i].position.latitude),
                parseFloat(res.data.served_in_route_in_range[i].position.longitude)],
              { color: '#1676e5', fillColor: '#1676e5', fillOpacity: 0.5, radius: 5 })
              .addTo(map).bindPopup(popup({tag: res.data.served_in_route_in_range[i].tag,  code: res.data.served_in_route_in_range[i].container?.name,
                time: res.data.served_in_route_in_range[i].event_time}));

          containers[i] = container;
          bounds.extend(container.getBounds());
          map.fitBounds(bounds);
        }


        for (const i in res.data.served_out_route) {
          let container = L.circle([
                parseFloat(res.data.served_out_route[i].position.latitude),
                parseFloat(res.data.served_out_route[i].position.longitude)],
              { color: '#eeeb4e', fillColor: '#eeeb4e', fillOpacity: 0.5, radius: 5 })
              .addTo(map).bindPopup(popup({tag: res.data.served_out_route[i].tag,  code: res.data.served_out_route[i].container?.name,
                time: res.data.served_out_route[i].event_time}));

          containers[i] = container;
          bounds.extend(container.getBounds());
          map.fitBounds(bounds);
        }


        for (const i in res.data.need_to_serve) {
          let container = L.circle([
                parseFloat(res.data.need_to_serve[i].position.latitude),
                parseFloat(res.data.need_to_serve[i].position.longitude)],
              { color: 'red', fillColor: 'red', fillOpacity: 0.5, radius: 5 })
              .addTo(map).bindPopup(popup({tag: res.data.need_to_serve[i].tag, code: res.data.need_to_serve[i].container?.name,
                time: res.data.need_to_serve[i].event_time}));

          containers[i] = container;
          bounds.extend(container.getBounds());
          map.fitBounds(bounds);
        }
      })

      map = L.map(mapElement.value, {center: [24.1307751,39.7842496], zoom: 6 })
      const googleStreets = L.tileLayer('https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',{ maxZoom: 20, subdomains:['mt0','mt1','mt2','mt3'] }).addTo(map);
      const googleHybrid = L.tileLayer('https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',{ maxZoom: 20, subdomains:['mt0','mt1','mt2','mt3'] })
      L.control.layers({googleStreets, googleHybrid}, {},{
        position: 'topleft'}).addTo(map)
    })


    const popup = data => {
      return `<div class="circle-popup">
              <table class="table table-sm table-bordered">
                <tr><td>tag</td><td>${data.tag}</td></tr>
                <tr><td>code</td><td>${data.code}</td></tr>
                <tr><td>time</td><td>${data.time}</td></tr>
              </table>
          </div>`;
    }

    onBeforeUnmount(() => {
      map.remove()
    })

    return {
      device,
      contract,
      mapElement,
      in_route_out_range,
      in_route_in_range,
      out_route, need_to_serve,
      plan_route_count
    }
  }
}


</script>

<style lang="less">

.report-box {
  position: absolute;
  width: 40%;
  right: 0;
  z-index: 99999;
  opacity: 0.95;
}

.toggle-div {
  min-width: 25%;
  background: #1b2337;
  text-align: center;
  padding: 5px;
}

.point {
  display:block;
  width: 10px;
  height: 10px;
  border-radius:50%;
  background: #00cfe8;
}


.leaflet-popup-content-wrapper {
  box-shadow: none;
  border-radius: 0;

}

</style>